module.exports = __webpack_public_path__ + "img/logoblack.5282db8d.svg";